export default __webpack_public_path__ + "static/media/spray.0c50ce09.svg";